import "./contact.css";
import ContactForm from "../../components/contact-form/contact-form";
import { Trans, useTranslation } from "react-i18next";
export default function Contact() {
  const { t } = useTranslation();
  return (
    <div className="contact-us-section">
      <div className="contact-form">
        <h6 className="contact-us-heading">{t("Contact Us")}</h6>
        <div className="contact-form-section">
            <h1>
              <Trans i18nKey={"Have a Vision? Let's Talk!"}>Have a Vision? Let's Talk! <br/></Trans></h1>
            <p>{t("We're happy to have you here, we look forward to work with you soon")}</p>
        </div>
        <ContactForm />
      </div>
      <div className="get-in-touch-section">
        <div>
          <h1>{t("Feel Free To Get In Touch")}</h1>
          <p>
            {t("With close to Two Decades of experience, we can deliver great results for your business with a professional approach and processes.")}
          </p>
        </div>

        <div className="contact-grid">
          <div className="contact-card-container">
            <div className="icon-box">
              <i className="fa-solid fa-envelope"></i>
            </div>
            <h3 className="contact-title">{t("Email Address")}</h3>
            <a href="mailto:contact@sigvion.com" className="contact-info">contact@sigvion.com</a>
          </div>

          <div className="contact-card-container">
            <div className="icon-box">
              <i className="fa-solid fa-phone"></i>
            </div>
            <h3 className="contact-title">{t("Phone")}</h3>
            <p className="contact-info">USA: <a href="tel:+16504279816">+1 6504279816</a></p>
            <p className="contact-info">India: <a href="tel:+919381362469">+91 9381362469</a></p>
          </div>

          <div className="contact-card-container">
            <div className="icon-box">
              <i className="fa-solid fa-location-dot"></i>
            </div>
            <h3 className="contact-title">USA</h3>
            <p className="contact-info">
              805 Marbella Vista way,<br/> 
              Leander, TX, 78641 <br/> 
              USA
            </p>
          </div>

          <div className="contact-card-container">
            <div className="icon-box">
              <i className="fa-solid fa-location-dot"></i>
            </div>
            <h3 className="contact-title">India</h3>
            <p className="contact-info">
              #308, DSL ABACUS IT Park, <br/>
                Industrial Development Area, Uppal,
                Secunderabad, INDIA
            </p>
          </div>

        </div>
      </div>
    </div>
  );
}
